import { useContext, useEffect, useState, useTransition } from "react";

import { isValidPositiveNumber, NO_VALUE_DISPLAY } from "@ryde/shared";

import { DropdownSourceContext } from "../../contexts";

export interface ISupplierTitleDto {
  title: string;
}

const emptySupplierTitle = (): ISupplierTitleDto => ({
  title: NO_VALUE_DISPLAY,
});

export const useSupplierTitle = (
  supplierId: number | undefined,
): ISupplierTitleDto => {
  const { getDropdownItems } = useContext(DropdownSourceContext);
  const [supplierTitleDto, setSupplierTitleDto] = useState<ISupplierTitleDto>(
    () => emptySupplierTitle(),
  );
  const [, startTransition] = useTransition();

  useEffect(() => {
    const fetchTitle = async (): Promise<void> => {
      if (!isValidPositiveNumber(supplierId)) {
        setSupplierTitleDto(emptySupplierTitle());
        return;
      }

      const items = await getDropdownItems("supplier");
      const item = items.find(x => Number(x.value) === supplierId);

      if (!item) {
        setSupplierTitleDto(emptySupplierTitle());
        return;
      }

      setSupplierTitleDto({
        title: item.label || NO_VALUE_DISPLAY,
      });
    };

    startTransition(() => {
      void fetchTitle();
    });
  }, [supplierId, getDropdownItems]);

  return supplierTitleDto;
};
